export function getdata() {
	var obj = {
		mboptions: [
			{
				label: "税局模板",
				value: "2"
			},
			{
				label: "标准模板",
				value: "0"
			},
			{
				label: "自定义模板",
				value: "1"
			}
		],
		typeing: [{
				label: "增值税发票",
				value: "0"
			}, {
				label: "航运行程单",
				value: "1"
			}, {
				label: "过路费",
				value: "2"
			}, {
				label: "火车票",
				value: "3"
			}, {
				label: "出租车票",
				value: "4"
			}, {
				label: "汽车票",
				value: "5"
			}, {
				label: "定额发票",
				value: "6"
			}, {
				label: "船票",
				value: "7"
			},

		]
	}
	return obj
}
